<template>
  <div>
    <search-profile @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a @click="updateEimData(record)" :disabled="updatingId === record.id">更新</a>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findProfiles, updateProfileEimData } from '@/api/profile'
import Pagination from '@/components/Pagination'
import SearchProfile from '@/views/profiles/Search'

export default {
  name: 'ProfileList',
  components: {
    Pagination,
    SearchProfile
  },
  data() {
    return {
      data: [],
      loading: true,
      updatingId: 0,
      pagination: {
        total_count: 0
      },
      query: {
        per_page: 10
      },
      columns: [
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          width: 220,
          fixed: 'left'
        },
        {
          title: '产品名称',
          dataIndex: 'product_name',
          width: 160
        },
        {
          title: '状态（EIM）',
          dataIndex: 'eim_status_text',
          width: 120
        },
        {
          title: '关联 EID',
          dataIndex: 'eid',
          width: 320,
          ellipsis: true
        },
        {
          title: '订单编号',
          dataIndex: 'order_no',
          width: 160
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        },
        {
          title: '操作',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' },
          width: 80,
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page }, search)
      this.fetchData()
    },
    updateEimData(record) {
      if (!record || !record.id) return
      this.updatingId = record.id
      updateProfileEimData(record.id).then((res) => {
        this.updatingId = 0
        if (res.code === 0) {
          this.$message.success(res.message || '操作成功，请稍后刷新查看')
        }
      }).catch(() => {
        this.updatingId = 0
      })
    },
    fetchData() {
      this.loading = true
      findProfiles(Object.assign({ agent_id: this.$store.getters.userAgentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
